import { get } from 'lodash';
export default (bundle, key) => {
    return get(bundle, key);
};